(function ($) {
  const state = {
    depotDetails: {},
    locationData: null,
    locationsPromise: null,
    outcodeToDepot: {},
  };

  const normalizePostcode = (postcode) => {
    const normalized = postcode ? postcode.toString().trim().toUpperCase() : '';
    return normalized.replace(/\s+/g, ' ').trim();
  };

  const isValidPostcode = (postcode, allowOutcode = false) => {
    const normalized = normalizePostcode(postcode).replace(/\s/g, '');
    const fullRegex = /^(GIR0AA|[A-PR-UWYZ][A-HK-Y]?[0-9][0-9ABEHMNPRVWXY]?[0-9][ABD-HJLNP-UW-Z]{2})$/i;
    const outcodeRegex = /^[A-PR-UWYZ][A-HK-Y]?[0-9][0-9ABEHMNPRVWXY]?$/i;

    if (fullRegex.test(normalized)) {
      return true;
    }

    return allowOutcode ? outcodeRegex.test(normalized) : false;
  };

  const extractOutcode = (postcode) => {
    const normalized = normalizePostcode(postcode);
    const parts = normalized.split(' ');
    if (parts.length > 1) {
      return parts[0];
    }

    const compact = normalized.replace(/\s/g, '');
    const outcodePattern = /^([A-Z]{1,2}[0-9][0-9A-Z]?)/;
    const matches = compact.match(outcodePattern);

    if (matches && matches[1]) {
      return matches[1];
    }

    return '';
  };

  const collectDepotDetails = () => {
    const depotMap = {};
    const blocks = $('.wpb_text_column');

    if (!blocks.length) {
      return depotMap;
    }

    blocks.each((_, column) => {
      const headings = $(column).find('h3');

      headings.each((__, heading) => {
        const text = $(heading).text().trim();
        const match = text.match(/^(.*)\s+Depot/i);

        if (match && match[1]) {
          const depotName = match[1].trim();
          const depotKey = depotName.toLowerCase();

          depotMap[depotKey] = {
            title: depotName,
            html: $(column).html(),
          };
        }
      });
    });

    return depotMap;
  };

  const renderError = (message) => {
    $('.office-title-wrap').hide();
    $('.office-locator-address').html(`<div class="error">${message}</div>`);
  };

  const loadLocations = () => {
    if (!state.locationsPromise) {
      const jsonUrl = window.infrasupportPostcodes && window.infrasupportPostcodes.jsonUrl
        ? window.infrasupportPostcodes.jsonUrl
        : '';

      state.locationsPromise = new Promise((resolve, reject) => {
        if (!jsonUrl) {
          reject(new Error('No postcode data available.'));
          return;
        }

        fetch(jsonUrl, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Could not load postcode data.');
            }

            return response.json();
          })
          .then((data) => {
            state.locationData = data || {};
            state.outcodeToDepot = {};

            if (state.locationData.depots) {
              Object.keys(state.locationData.depots).forEach((depotName) => {
                const outcodes = state.locationData.depots[depotName];

                if (Array.isArray(outcodes)) {
                  outcodes.forEach((outcode) => {
                    state.outcodeToDepot[outcode] = depotName;
                  });
                }
              });
            }

            resolve(state.locationData);
          })
          .catch((error) => reject(error));
      });
    }

    return state.locationsPromise;
  };

  const findPostalCodeComponent = (results) => {
    for (let i = 0; i < results.length; i += 1) {
      const zipcodeObject = results[i].address_components.find(address => address.types.includes('postal_code'));

      if (zipcodeObject !== undefined) {
        const matched = zipcodeObject.long_name || zipcodeObject.short_name;
        const normalized = normalizePostcode(matched);

        if (isValidPostcode(normalized, true)) {
          return normalized;
        }
      }
    }

    return '';
  };

  const getZipCode = (input) => new Promise((resolve, reject) => {
    const normalizedInput = normalizePostcode(input);

    if (isValidPostcode(normalizedInput, true)) {
      resolve(normalizedInput);
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
      reject(new Error('Geocoding unavailable'));
      return;
    }

    const moreCompleteAddress = `${input}, United Kingdom`;
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({
      address: moreCompleteAddress,
    }, (results1, status1) => {
      if (status1 === google.maps.GeocoderStatus.OK && results1.length) {
        const postalComponent = findPostalCodeComponent(results1);

        if (postalComponent) {
          resolve(normalizePostcode(postalComponent));
          return;
        }

        const latitude = results1[0].geometry.location.lat();
        const longitude = results1[0].geometry.location.lng();

        geocoder.geocode({
          location: new google.maps.LatLng(latitude, longitude),
        }, (results2, status2) => {
          if (status2 === google.maps.GeocoderStatus.OK && results2.length) {
            const secondPostal = findPostalCodeComponent(results2);

            if (secondPostal) {
              resolve(normalizePostcode(secondPostal));
              return;
            }

            reject(new Error('Could not resolve postal code from location.'));
            return;
          }

          reject(new Error('Geocoding failed in second lookup'));
        });
        return;
      }

      reject(new Error('Geocoding failed'));
    });
  });

  const getBUKOLocation = (zipcode) => {
    if (!state.locationData || !state.locationData.depots) {
      return null;
    }

    const outcode = extractOutcode(zipcode);

    if (!outcode) {
      return null;
    }

    const depot = state.outcodeToDepot[outcode];

    if (!depot) {
      return null;
    }

    return {
      outcode,
      depot,
    };
  };

  const updateLocation = (zipcode) => {
    const location = getBUKOLocation(zipcode);
    const addressContainer = $('.office-locator-address');
    const titleWrap = $('.office-title-wrap');

    titleWrap.hide();

    if (!location) {
      return false;
    }

    const depotName = location.depot || '';
    const depotKey = depotName.toLowerCase();
    const depotInfo = depotKey && state.depotDetails[depotKey] ? state.depotDetails[depotKey] : null;
    const isValidDepot = depotName !== 'No depot';
    const depotDisplayName = isValidDepot ? `${depotName} Depot` : depotName;
    let renderedHtml = '';

    if (depotInfo) {
      renderedHtml = depotInfo.html;
    } 

    addressContainer.html(renderedHtml);
    titleWrap.find('.office-title').html(depotDisplayName);
    titleWrap.show();

    return true;
  };

  const handleSearch = () => {
    const input = $('.office-locator-input').val().trim();

    if (!input.length) {
      $('.office-locator-loader').hide();
      $('.office-title-wrap').hide();
      $('.office-locator-address').html('');
      return;
    }

    $('.office-locator-loader').show();

    loadLocations()
      .then(() => getZipCode(input))
      .then((zipcode) => {
        const updated = updateLocation(zipcode);

        if (!updated) {
          renderError('No matching depot found for this postcode.');
        }
      })
      .catch(() => {
        renderError('Er was een probleem met de invoer, controleer het veld hierboven op typefouten.');
      })
      .finally(() => {
        $('.office-locator-loader').hide();
      });
  };

  const bindSearch = () => {
    const officeLocatorInput = $('.office-locator-input');
    if (!officeLocatorInput.length) {
      return;
    }

    state.depotDetails = collectDepotDetails();
    officeLocatorInput.off('keyup.postcodeOverride');

    let searchTimeout = null;
    officeLocatorInput.on('keyup.postcodeOverride', () => {
      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(() => {
        handleSearch();
      }, 500);
    });
  };

  $(document).ready(() => {
    bindSearch();
  });
}(window.jQuery));

